import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AcknowledementConstants } from '../acknowledement-constants';
import { DeleteAcknowledgement } from '../models/delete-acknowledgement';
import { AcknowledgementService } from '../services/acknowledgement.service';

@Component({
  selector: 'app-delete-acknowledgement',
  templateUrl: './delete-acknowledgement.component.html',
  styleUrls: ['./delete-acknowledgement.component.scss']
})
export class DeleteAcknowledgementComponent implements OnInit {

  constructor(private acknowledgementService:AcknowledgementService, private messageService: MessageService) { }
  errorMessages: string[] = [];
  @Input() isDeleteAcknowledgementModal!:boolean;
  @Input() acknowledgementId!: string;
  @Output() isDeleteAcknowledgementModalVisible=new EventEmitter<boolean>();
  reason!: string;
  deleteAcknowledgement!:DeleteAcknowledgement;
  mandatoryFields = this.getDefaultMandatoryFields();
  valueField: string = 'value';
  labelField: string = 'name';
  display: boolean = true;

  ngOnInit(): void {
  }


  confirmDeleteAcknowledgement():void{
    this.errorMessages=[];
    this.validatDeleteAcknowledgementControls();
    if(this.errorMessages.length === 0){
      this.deleteAcknowledgement = {
        acknowledgementId: this.acknowledgementId,
        reason: this.reason,
      }
      this.acknowledgementService.deleteAcknowledgementDetails(this.deleteAcknowledgement)
      .subscribe({
        complete:()=>{
          setTimeout(() => {
            this.messageService.add({
              severity: AcknowledementConstants.Severity_Success,
              summary: `${AcknowledementConstants.Delete_Acknowledgement_success_Message}`
            });
            this.isDeleteAcknowledgementModal=false;
          this.isDeleteAcknowledgementModalVisible.emit(this.isDeleteAcknowledgementModal);
          }, 100);
        }
      }
      )
    }
  }

  cancel():void{
    this.isDeleteAcknowledgementModal=false;
    this.isDeleteAcknowledgementModalVisible.emit(this.isDeleteAcknowledgementModal);
  }
  
  getDefaultMandatoryFields() {
    return {
      reason: false,
    }
  }

  private validatDeleteAcknowledgementControls(){
    const isWhitespace = (this.reason || '').trim().length === 0;
    if(this.reason === "" || this.reason === undefined || this.reason?isWhitespace:null){
          this.mandatoryFields.reason = true;
          this.errorMessages.push(AcknowledementConstants.ReasonErrorMessage); 
    }
  }

}
